document.addEventListener('DOMContentLoaded', function () {
	const tabButtons = document.querySelectorAll('.tab-btn');
	const tabs = document.querySelectorAll('.collection-tabs .tab');

	tabButtons.forEach((btn) => {
		btn.addEventListener('click', function () {
			const tabID = this.getAttribute('data-id');

			// Remove active class from all buttons
			tabButtons.forEach((b) => b.classList.remove('tab-btn--active'));

			// Add active class to clicked button
			this.classList.add('tab-btn--active');

			// Hide all tabs
			tabs.forEach((tab) => (tab.style.display = 'none'));

			// Show selected tab
			const activeTab = document.querySelector(
				`.collection-tabs .tab#${tabID}`
			);
			if (activeTab) {
				activeTab.style.display = 'block';
			}
		});
	});

	const buttons = document.querySelectorAll('.video-toggle');

	buttons.forEach((button) => {
		const playIcon = button.querySelector('.play');
		const pauseIcon = button.querySelector('.pause');

		button.addEventListener('click', () => {
			const videoId = button.getAttribute('data-video');
			const video = document.getElementById(videoId);

			if (!video) return;

			if (video.paused) {
				video.play();
				playIcon.style.display = 'none';
				pauseIcon.style.display = 'inline';
			} else {
				video.pause();
				playIcon.style.display = 'inline';
				pauseIcon.style.display = 'none';
			}
		});

		// keep button in sync if user plays/pauses via other means
		const videoId = button.getAttribute('data-video');
		const video = document.getElementById(videoId);
		if (video) {
			video.addEventListener('play', () => {
				playIcon.style.display = 'none';
				pauseIcon.style.display = 'inline';
			});
			video.addEventListener('pause', () => {
				playIcon.style.display = 'inline';
				pauseIcon.style.display = 'none';
			});
		}
	});

	document.querySelectorAll('.field__input[required]').forEach((input) => {
		const container = input.closest('.spacing-style');
		const heading = container?.querySelector('.__heading');

		if (heading && !heading.querySelector('.req')) {
			const span = document.createElement('span');
			span.className = 'req';
			span.textContent = '*';
			heading.appendChild(span);
		}
	});

	document
		.querySelector(
			'#shopify-section-sections--26008592417137__migrated_footer_content > div.section.section--page-width.color-scheme-2 > div.border-style.custom-section-content > div > div:nth-child(1) > div.group-block-content.layout-panel-flex.layout-panel-flex--row.mobile-column > div.group-block.group-block--height-fit.group-block--width-custom.border-style.spacing-style.size-style > a'
		)
		?.setAttribute('aria-label', 'Home Page Link');
});
